import React, { useEffect, useState, useMemo } from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { DatePicker } from '../../shared/DatePicker'
import { useTextResources } from '../../../language'
import { Form } from 'semantic-ui-react'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetOccupancyForecastData } from '../../../api/services/pms';
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import PropTypes from 'prop-types'
import { GetHotels } from '../../../api/services/organization'
import { onError } from '../../shared/messages'
import { dateFormat, dateFormatShort } from '../../shared/constants'

const GuestsForecastReport = ({ HotelID }) => {
    const text = useTextResources()
    const [searchState, setSearchState] = useState({})
    const [data, setData] = useState([])
    const [hotels, setHotels] = useState([])
    const days = 10

    useEffect(() => {
        (async () => {
            try {
                const hotels = await GetHotels()
                setHotels(hotels)
            } catch (error) {
                onError(error)
            }
        })()
    }, [HotelID])

    const onSearchChange = (search) => {
        if (!search.StartDate) {
            search.StartDate = moment().startOf("day").toDate();
        }
        setSearchState(search)
    }

    const onSearchComplete = (data, searchState) => {
        setSearchState(searchState)
        const groups = {
            "TotalLocalGuests": text("Local"),
            "AdultsLocal": text("Local"),
            "ChildrenLocal": text("Local"),
            "InfantsLocal": text("Local"),
            "TotalTouristsGuests": text("Tourist"),
            "AdultsTourist": text("Tourist"),
            "ChildrenTourist": text("Tourist"),
            "InfantsTourist": text("Tourist"),
            "TotalGuests": text("TotalGuests"),
            "TotalInfants": text("TotalInfants"),
            "Arrivals": text("Arrivals"),
            "Departures": text("Departures"),
            "StaysOver": text("StaysOver"),
            "Occupied": text("Occupied"),
        }
        const rows = ["TotalLocalGuests", "AdultsLocal", "ChildrenLocal", "InfantsLocal", "TotalTouristsGuests", "AdultsTourist", "ChildrenTourist", "InfantsTourist", "TotalGuests", "TotalInfants", "Arrivals", "Departures", "StaysOver", "Occupied"]
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        let newData = rows.map(row => {
            let newRow = {
                "Description": text(row),
                "ID": row,
                "Group": groups[row]
            }
            for (let date of range.by("day")) {
                let reservationPerDate = data.reservations.filter(obj => date.isBetween(moment(obj.CheckInDate).startOf("day"), moment(obj.CheckOutDate).startOf("day"), undefined, '[]'))
                let localReservations = reservationPerDate.filter(r => r.Guest.Nationality?.CountryID === data.hotels[0].Location?.Country.Id)
                let touristReservations = reservationPerDate.filter(r => !r.Guest.Nationality || r.Guest.Nationality.CountryID !== data.hotels[0].Location?.Country.Id)

                switch (row) {
                    case 'TotalLocalGuests':
                        newRow[date.format(dateFormat)] =
                            localReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                                }
                                return initialValue
                            }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'AdultsLocal':
                        newRow[date.format(dateFormat)] =
                            localReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults
                                }
                                return initialValue
                            }, 0)
                        newRow["ParentId"] = "TotalLocalGuests"
                        break;
                    case 'ChildrenLocal':
                        newRow[date.format(dateFormat)] =
                            localReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Children
                                }
                                return initialValue
                            }, 0)
                        newRow["ParentId"] = "TotalLocalGuests"
                        break;
                    case 'InfantsLocal':
                        newRow[date.format(dateFormat)] = localReservations.reduce((initialValue, reservation) => {
                            const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                            if (reservationDailyAccommodations) {
                                return initialValue + reservationDailyAccommodations.Infants
                            }
                            return initialValue
                        }, 0)
                        newRow["ParentId"] = "TotalLocalGuests"
                        break;
                    case 'TotalTouristsGuests':
                        newRow[date.format(dateFormat)] =
                            touristReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                                }
                                return initialValue
                            }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'AdultsTourist':
                        newRow[date.format(dateFormat)] =
                            touristReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults
                                }
                                return initialValue
                            }, 0)
                        newRow["ParentId"] = "TotalTouristsGuests"
                        break;
                    case 'ChildrenTourist':
                        newRow[date.format(dateFormat)] =
                            touristReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Children
                                }
                                return initialValue
                            }, 0)
                        newRow["ParentId"] = "TotalTouristsGuests"
                        break;
                    case 'InfantsTourist':
                        newRow[date.format(dateFormat)] =
                            touristReservations.reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Infants
                                }
                                return initialValue
                            }, 0)
                        newRow["ParentId"] = "TotalTouristsGuests"
                        break;
                    case 'TotalGuests':
                        newRow[date.format(dateFormat)] = 
                        reservationPerDate.reduce((initialValue, reservation) => {
                            const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                            if (reservationDailyAccommodations) {
                                return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                            }
                            return initialValue
                        }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'TotalInfants':
                        newRow[date.format(dateFormat)] = 
                        reservationPerDate.reduce((initialValue, reservation) => {
                            const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                            if (reservationDailyAccommodations) {
                                return initialValue + reservationDailyAccommodations.Infants
                            }
                            return initialValue
                        }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'Arrivals':
                        newRow[date.format(dateFormat)] = 
                        reservationPerDate.filter(obj => moment(obj.CheckInDate).isSame(date.clone(), "day")).reduce((initialValue, reservation) => {
                            const reservationDailyAccommodations = reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                            if (reservationDailyAccommodations) {
                                return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                            }
                            return initialValue
                        }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'Departures':
                        newRow[date.format(dateFormat)] = 
                        reservationPerDate.filter(obj => moment(obj.CheckOutDate).isSame(date.clone(), "day")).reduce((initialValue, reservation) => {                            
                            return initialValue + reservation.Adults + reservation.Children + reservation.Infants                            
                        }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'StaysOver':                        
                        newRow[date.format(dateFormat)] =
                        reservationPerDate.filter(obj => !moment(obj.CheckInDate).isSame(date.clone(), "day")).reduce((initialValue, reservation) => {
                                const reservationDailyAccommodations =  reservation.ReservationDailyAccommodations.find(x => moment(x.Date).isSame(date.clone(), "day"));
                                if (reservationDailyAccommodations) {
                                    return initialValue + reservationDailyAccommodations.Adults + reservationDailyAccommodations.Children + reservationDailyAccommodations.Infants
                                }
                                return initialValue
                            }, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'Occupied':
                        newRow[date.format(dateFormat)] = 
                        reservationPerDate.filter(obj => !moment(obj.CheckOutDate).isSame(date.clone(), "day")).length
                        newRow["ParentId"] = null
                        break;
                }
            }
            return newRow

        })
        newData.forEach(row => {
            if (row.Description.startsWith('[Adults')) {
                row.Description = text("Adults")
            }
            if (row.Description.startsWith('[Children')) {
                row.Description = text("Children")
            }
            if (row.Description.startsWith('[Infants')) {
                row.Description = text("Infants")
            }
        })
        setData(newData)
    }
    const formatter = ({ value }) => {
        return <div style={{ fontSize: '1.2rem' }}>{value}</div>
    }
    const columns = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumns = Array.from(range.by("day")).map(day => {
            return {
                name: day.format(dateFormat),
                title: day.format(dateFormatShort),
                formatter
            }
        })
        return [
            { name: 'Description', title: text('Description'), formatter },
            { name: 'Group', title: text('Group') },
            ...dateColumns
        ]

    }, [data])


    const columnExtensions = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumnExtensions = Array.from(range.by("day")).map(day => {
            return {
                columnName: day.format(dateFormat),
                width: 135
            }
        })
        return [
            ...dateColumnExtensions
        ]
    }, [data])


    const customizeExcelHeader = worksheet => {
        const hotel = hotels.find(x => x.Id === HotelID)
        const row = worksheet.addRow([`${text("GuestsForecastReport")} ${hotel && hotel.Name}, ${moment(searchState.StartDate).format(dateFormat)} - ${moment(searchState.StartDate).add(days, "days").format(dateFormat)}`])
        worksheet.mergeCells('A1:O1');
        row.height = 20
        row.font = { bold: true, size: 16 };
    }
    const gridOptions = {
        search: {
            title: text("GuestsForecastReport"),
            fields: [
                <Form.Field control={HotelsDropDown} clearable width="4" label={text("Hotel")} key="HotelID" />,
                <DatePicker
                    type="basic"
                    label={text("StartDate")}
                    name="StartDate"
                    key="StartDate"
                />
            ],
            initial: {
                "StartDate": moment().startOf("day").toDate(),
                "HotelID": HotelID
            },
            api: GetOccupancyForecastData,
            spec: {
                EndDate: moment(searchState.StartDate).add(days, "days").toISOString()
            },
            groupSize: 6
        },
        grid: {
            columns: columns,
            tree: {
                getChildRows: (row, rootRows) => {
                    const childRows = rootRows.filter(r => r.ParentId === (row ? row.ID : null));
                    return childRows.length ? childRows : null;
                },
                treeColumnName: "Description"
            },
            summary: true,
            export: true,
            pdf: true,
            customOptions: {
                hidden: {
                    hiddenColumns: [{ columnName: 'Group' }]
                }
            },
            columnExtensions: columnExtensions,
            excel: {
                customizeHeader: customizeExcelHeader,
                grouping: [{ columnName: "Group" }],
                totalSummaryItems: [
                    { columnName: "Group", type: 'sum' }
                ],
            },
        }
    }

    return (<GridSearchTemplate options={gridOptions} onSearchComplete={onSearchComplete} onSearchChange={onSearchChange} data={data} />)
}

GuestsForecastReport.propTypes = {
    HotelID: PropTypes.any
}
export default GuestsForecastReport